import toaster from '../toaster';

const useErrorHandler = () => {
  // const navigate = useNavigate();
  // const queryClient = useQueryClient();
  // const dispatch = useAppDispatch();

  const handleError = (error: any) => {
    const { response } = error;

    switch (response?.status) {
      case 400:
      case 404:
      case 403:
      case 409:
      case 500:
        toaster.error(response?.data?.errors?.join(', ') || response?.data?.message);
        break;
      // case 401:
      //   toaster.error('Session expired');
      //   // stop all going queries
      //   queryClient.clear();
      //   queryClient.cancelQueries();

      //   dispatch(logout());
      //   // redirect to login
      //   navigate('/login');
      //   break;
      default:
        toaster.error('Something went wrong');
    }
  };
  return { handleError };
};

export default useErrorHandler;
